/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.testimonial-slider' ).length ) {
        $( '.testimonial-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            pagination: false,
            arrows: true,
            gap: '32px',
            autoWidth: false,
            perPage: 3,
            perMove: 1,
            breakpoints: {
              1100: {
                perPage: 2,
              },
              768: {
                perPage: 1,
                gap: '20px',
              },
            },
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );
